import { PublicShell } from "./public-shell"

interface PublicNoticeProps {
  icon: React.ReactNode
  title: string
  description: React.ReactNode
  children?: React.ReactNode
}

export function PublicNotice({ icon, title, description, children }: PublicNoticeProps) {
  return (
    <PublicShell>
      <div className="max-w-sm text-center">
        {icon}
        <h1 className="mt-4 text-xl font-semibold">{title}</h1>
        <p className="text-muted-foreground mt-2 text-sm">{description}</p>
        {children && <div className="mt-4">{children}</div>}
      </div>
    </PublicShell>
  )
}
